import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
// hooks
import useResponsive from "../hooks/useResponsive";
// components
import Page from "../components/Page";
import Logo from "../components/Logo";
// sections
import { LoginForm } from "../sections/auth/login";
import AuthSocial from "../sections/auth/AuthSocial";
//redux
import { useSelector } from "react-redux";
//translations
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { RegistrationStatus } from "../common/enum";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./login.css"
// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  padding: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "50%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
  height: "96vh",
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  // const smUp = useResponsive("up", "sm");

  const mdUp = useResponsive("up", "md");
  const {
    translate,
    auth: { user },
  } = useSelector((state) => state); // import { Card, Link, Container, Typography, Divider } from "@mui/material";

  const { t } = useTranslation();

  const navigate = useNavigate();

  React.useEffect(() => {
    if (
      Object.keys(user).length > 0 &&
      user.userId &&
      user.token &&
      user.staus !== undefined
    ) {
      switch (user.status) {
        case RegistrationStatus.active:
          navigate("/dashboard");
          break;
        case RegistrationStatus.registering:
          navigate("/multistep");
          break;
        default:
          break;
      }
    }
  }, [user, navigate]);

  React.useEffect(() => {
    i18n.changeLanguage(translate);
  }, [translate]);

  return (
    <Page
      title="Login"
      sx={{
        backgroundColor: "#FDFDFD",
      }}
    >
      <RootStyle>
        <HeaderStyle>
          {/* <Logo /> */}

          {/* {smUp && (
            <Typography variant="body2" sx={{ mt: { md: -2 } }}>
              Don’t have an account? {""}
              <Link variant="subtitle2" component={RouterLink} to="/register">
                Get started
              </Link>
            </Typography>
          )} */}
        </HeaderStyle>

        {mdUp && (
          <SectionStyle
            sx={{ position: "relative" }}
          >
            <Carousel
              showThumbs={false}
              showStatus={false}
              autoPlay
              infiniteLoop
              showArrows={false}
              swipeable
              dynamicHeight={true}
            >
              <div>
                <img src="/static/illustrations/login-slide1.jpg" alt="Slide 1 carrousel" />
              </div>
              <div >
                <img src="/static/illustrations/login-slide2.jpg" alt="Slide 2 carrousel" />
              </div>
              <div>
                <img src="/static/illustrations/login-slide3.jpg" alt="Slide 3 carrousel" />
              </div>
            </Carousel>
            <Box
              sx={{
                position: "absolute",
                bottom: "0",
                background: "#37773E",
                color: "white",
                opacity: "0.75",
                fontSize: "20px",
                padding: "20px",
                textAlign: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {/* <Typography>sdasdasdfas</Typography> */}
            </Box>
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Typography variant="h1" gutterBottom align="center" style={{ fontSize: '18px' }}>
              {t("logintitle")}!
            </Typography>

            {/* <Typography sx={{ color: "text.secondary", mb: 5 }} align="justify">
              Qui tempore quidem nulla pariatur aut enim sapiente. Modi error
              omnis. Ex deserunt ut aperiam amet quas iste et non. Aceder{" "}
            </Typography> */}

            <LoginForm t={t} />

            {/* <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {t("authOptions")}
              </Typography>
            </Divider> */}
            {/* <AuthSocial /> */}

            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              {t("dontHaveAccount")}{" "}
              <Link variant="subtitle2" component={RouterLink} to="/register">
                {t("createAccount")}
              </Link>
            </Typography>
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
